import { render, staticRenderFns } from "./quanXian.vue?vue&type=template&id=235578f0&"
import script from "./quanXian.vue?vue&type=script&lang=js&"
export * from "./quanXian.vue?vue&type=script&lang=js&"
import style0 from "./quanXian.vue?vue&type=style&index=0&id=235578f0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports